import React, {FC} from 'react';

import {ChannelModel} from '../../../../models/api/channelModel';
import {ChannelErrorBannerContainer} from './channelErrorBannerContainer';

/*
 * Props.
 */

interface ChannelErrorBannersProps {
  errorChannels: ReadonlyArray<ChannelModel>;
}

/*
 * Component.
 */

export const ChannelErrorBanners: FC<ChannelErrorBannersProps> = (props) => (
  <>
    {props.errorChannels.map((c) => (
      <ChannelErrorBannerContainer key={`channel-error-${c.id}`} channel={c} />
    ))}
  </>
);
